(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["abrimos-espera"] && !Shopify.designMode) return;
  try {
    
  /* Abrimos: cuenta regresiva en días (hora de la CDMX), alta sin recargar la página y aviso si el correo no se ve completo */
  (function () {
    function inicio() {
      var el = document.querySelector('[data-abr-fecha]');
      if (el) {
        var meta = new Date(el.getAttribute('data-abr-fecha') + 'T00:00:00-06:00');
        var dias = Math.ceil((meta - Date.now()) / 86400000);
        if (!isNaN(dias) && dias > 0) {
          el.textContent = dias === 1 ? 'Falta 1 día' : 'Faltan ' + dias + ' días';
          el.hidden = false;
        }
      }
      /* Si el alta llegó recargando la página (sin JavaScript o con la verificación de Shopify), Shopify
         regresa con #abr-form… y el navegador brinca al formulario: se quita y se vuelve arriba. */
      var listo = document.querySelector('.abr .abr__listo');
      if (!listo) return;
      listo.closest('.abr').classList.add('is-listo');
      if (location.hash.indexOf('#abr-form') !== 0) return;
      history.replaceState(null, '', location.pathname);
      function arriba() {
        window.scrollTo({ top: 0, behavior: 'instant' });
        if (listo.getBoundingClientRect().bottom > window.innerHeight) listo.scrollIntoView({ block: 'center', behavior: 'instant' });
      }
      arriba();
      if (document.readyState !== 'complete') window.addEventListener('load', arriba, { once: true });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', inicio);
    else inicio();

    function listoEn(form) {
      var seccion = form.closest('.abr');
      var pedir = form.querySelector('.abr__pedir');
      var listo = document.createElement('p');
      listo.className = 'abr__listo';
      listo.setAttribute('role', 'status');
      listo.tabIndex = -1;
      listo.textContent = seccion.getAttribute('data-abr-listo') || '';
      function cambia() {
        if (pedir) pedir.replaceWith(listo);
        else form.prepend(listo);
        form.removeAttribute('aria-busy');
        seccion.classList.add('is-listo');
        listo.focus({ preventScroll: true });
      }
      if (pedir && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        pedir.classList.add('is-saliendo');
        setTimeout(cambia, 180);
      } else cambia();
    }

    function enviaNormal(form) {
      HTMLFormElement.prototype.submit.call(form);
    }

    function esAbr(form) {
      return form && form.classList && form.classList.contains('abr__form');
    }

    /* Mientras se manda, el botón dice «Un momento…» y no se puede volver a picar */
    function ocupa(form, si) {
      var boton = form.querySelector('button[type="submit"]');
      if (si) form.setAttribute('aria-busy', 'true');
      else form.removeAttribute('aria-busy');
      if (!boton) return;
      if (!boton.hasAttribute('data-texto')) boton.setAttribute('data-texto', boton.textContent);
      boton.disabled = si;
      boton.textContent = si ? (boton.getAttribute('data-enviando') || boton.getAttribute('data-texto')) : boton.getAttribute('data-texto');
    }

    function devuelve(form, mensaje) {
      var campo = form.querySelector('input[type="email"]');
      var estado = form.querySelector('.abr__estado');
      form.removeAttribute('data-mandando');
      ocupa(form, false);
      if (campo) { campo.setAttribute('aria-invalid', 'true'); campo.focus(); }
      if (estado) estado.textContent = mensaje || estado.getAttribute('data-error') || '';
    }

    /* Alta sin recargar: se manda lo mismo que el formulario y se lee la respuesta de Shopify */
    function envia(form) {
      if (!window.fetch || !window.DOMParser) return enviaNormal(form);
      if (form.getAttribute('data-mandando') === 'true') return;
      form.setAttribute('data-mandando', 'true');
      ocupa(form, true);
      fetch(form.action, { method: 'POST', body: new FormData(form), credentials: 'same-origin', headers: { Accept: 'text/html' } })
        .then(function (r) {
          /* Si Shopify pide verificar a mano que no es un robot, se manda como siempre y su página lo resuelve */
          if (r.url.indexOf('/challenge') !== -1) throw new Error('verificación');
          return r.text().then(function (html) { return { url: r.url, html: html }; });
        })
        .then(function (res) {
          var doc = new DOMParser().parseFromString(res.html, 'text/html');
          if (res.url.indexOf('customer_posted=true') !== -1 || doc.querySelector('.abr__listo')) {
            form.removeAttribute('data-mandando');
            return listoEn(form);
          }
          var error = doc.querySelector('.abr__estado');
          devuelve(form, error ? error.textContent.trim() : '');
        })
        .catch(function () { enviaNormal(form); });
    }

    /* La verificación antirrobots de Shopify (hCaptcha) detiene el envío, revisa y al final llama a
       form.submit(). Guarda el submit que encuentra al conectarse, así que se cambia por el envío sin
       recargar antes de que alguien toque el campo. */
    function prepara() {
      document.querySelectorAll('.abr__form').forEach(function (form) {
        if (form.hasAttribute('data-preparado')) return;
        form.setAttribute('data-preparado', '');
        try { form.submit = function () { envia(form); }; } catch (err) {}
      });
    }
    prepara();
    document.addEventListener('DOMContentLoaded', prepara);

    /* Primero se revisa el correo; si no se ve completo, no sigue nadie (ni la verificación de Shopify) */
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!esAbr(form)) return;
      var campo = form.querySelector('input[type="email"]');
      var estado = form.querySelector('.abr__estado');
      if (!campo) return;
      if (!campo.value.trim() || !campo.checkValidity()) {
        e.preventDefault();
        e.stopImmediatePropagation();
        campo.setAttribute('aria-invalid', 'true');
        if (estado) estado.textContent = estado.getAttribute('data-error') || '';
        campo.focus();
        return;
      }
      campo.removeAttribute('aria-invalid');
      if (estado) estado.textContent = '';
      ocupa(form, true);
      /* Si la verificación de Shopify no termina (se cierra o falla), el botón se suelta solo */
      clearTimeout(form._abrEspera);
      form._abrEspera = setTimeout(function () {
        if (form.getAttribute('data-mandando') !== 'true') ocupa(form, false);
      }, 20000);
    }, true);

    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!esAbr(form)) return;
      if (e.defaultPrevented) {
        /* Lo detuvo la verificación de Shopify: si ya está conectada, ella llama al envío cuando termine;
           si todavía no carga, el envío se pierde y el botón se suelta para volver a picarlo. */
        if (!form.hasAttribute('data-hcaptcha-bound')) ocupa(form, false);
        return;
      }
      e.preventDefault();
      envia(form);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ayuda-contenido"]) return;
  try {
    
  /* Ayuda: el índice marca el tema que estás leyendo */
  (() => {
    const iniciar = (raiz) => {
      const nav = raiz && raiz.querySelector('[data-indice]');
      if (!nav || nav.dataset.listo) return;
      nav.dataset.listo = '1';
      const ligas = [...nav.querySelectorAll('a[href^="#"]')];
      const temas = ligas.map(a => document.getElementById(decodeURIComponent(a.hash.slice(1)))).filter(Boolean);
      if (!temas.length) return;
      let pendiente = false;
      const marcar = () => {
        pendiente = false;
        const linea = window.innerHeight * 0.35;
        let actual = null;
        for (const t of temas) if (t.getBoundingClientRect().top <= linea) actual = t;
        ligas.forEach(a => {
          const es = actual && a.hash === '#' + actual.id;
          if (es) a.setAttribute('aria-current', 'true');
          else a.removeAttribute('aria-current');
        });
      };
      const pedir = () => { if (!pendiente) { pendiente = true; requestAnimationFrame(marcar); } };
      window.addEventListener('scroll', pedir, { passive: true });
      window.addEventListener('resize', pedir);
      marcar();
    };
    const todo = () => document.querySelectorAll('[data-ayuda]').forEach(iniciar);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', todo);
    else todo();
    document.addEventListener('shopify:section:load', e => e.target.querySelectorAll('[data-ayuda]').forEach(iniciar));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["busqueda-campo"]) return;
  try {
    
  /* Buscar mientras escribes. Pide a Shopify la sección de resultados con la misma búsqueda (?section_id=)
     y la cambia en su lugar; la dirección guarda lo que buscaste. Si algo falla, el formulario se manda normal. */
  (() => {
    let espera = 0;
    let control = null;
    let ultima = null;

    const partes = () => {
      const form = document.querySelector('[data-bq-form]');
      const caja = document.querySelector('[data-bq-resultados]');
      return {
        form,
        input: form && form.querySelector('[data-bq-q]'),
        estado: form && form.querySelector('[data-bq-estado]'),
        borrar: form && form.querySelector('[data-bq-borrar]'),
        caja
      };
    };

    const urlDe = (form, conSeccion) => {
      const datos = new FormData(form);
      const q = String(datos.get('q') || '').trim().replace(/\s+/g, ' ');
      const p = new URLSearchParams();
      if (q) {
        datos.forEach((v, k) => { if (k !== 'q' && v !== '') p.append(k, v); });
        p.set('q', q);
      }
      if (conSeccion) p.set('section_id', conSeccion);
      const s = p.toString();
      return form.getAttribute('action') + (s ? '?' + s : '');
    };

    const copiarEstado = () => {
      const { estado, caja } = partes();
      if (estado && caja && caja.dataset.estado !== undefined) estado.textContent = caja.dataset.estado;
    };

    const buscar = (opciones = {}) => {
      const { form, input, borrar, caja } = partes();
      if (!form || !caja) return Promise.resolve(false);
      const q = input.value.trim();
      if (borrar) borrar.hidden = !q;
      const visible = urlDe(form);
      if (visible === ultima && !opciones.forzar) return Promise.resolve(true);
      ultima = visible;
      if (control) control.abort();
      control = new AbortController();
      const sid = caja.dataset.seccion;
      caja.setAttribute('aria-busy', 'true');
      return fetch(urlDe(form, sid), { signal: control.signal, headers: { Accept: 'text/html' } })
        .then(r => { if (!r.ok) throw new Error(r.status); return r.text(); })
        .then(html => {
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const nueva = doc.querySelector('[data-bq-resultados]');
          if (!nueva) throw new Error('sin resultados');
          const actual = partes().caja;
          actual.replaceWith(nueva);
          copiarEstado();
          try { history.replaceState(history.state, '', visible); } catch (e) { /* sin historial */ }
          document.dispatchEvent(new CustomEvent('patio:busqueda', { detail: { q } }));
          return true;
        })
        .catch(err => {
          if (err && err.name === 'AbortError') return false;
          const c = partes().caja;
          if (c) c.removeAttribute('aria-busy');
          if (opciones.alFallar) window.location.href = visible;
          return false;
        });
    };

    document.addEventListener('input', e => {
      if (!e.target.matches || !e.target.matches('[data-bq-q]')) return;
      const { borrar } = partes();
      if (borrar) borrar.hidden = !e.target.value.trim();
      clearTimeout(espera);
      const v = e.target.value.trim();
      if (v.length === 1) return; /* una letra sola trae medio catálogo: espera la segunda */
      espera = setTimeout(() => buscar(), 280);
    });

    document.addEventListener('submit', e => {
      const form = e.target.closest && e.target.closest('[data-bq-form]');
      if (!form || !partes().caja) return;
      e.preventDefault();
      clearTimeout(espera);
      buscar({ forzar: true, alFallar: true }).then(ok => {
        const { input, estado } = partes();
        if (ok && input && input.value.trim() && window.matchMedia('(pointer: coarse)').matches) {
          input.blur();
          if (estado) estado.focus({ preventScroll: true });
        }
      });
    });

    document.addEventListener('click', e => {
      const b = e.target.closest && e.target.closest('[data-bq-borrar]');
      if (b) {
        const { input } = partes();
        if (!input) return;
        input.value = '';
        b.hidden = true;
        buscar();
        input.focus();
        return;
      }
      /* Las sugerencias y «Prueba con…» llenan el campo y buscan aquí mismo */
      const s = e.target.closest && e.target.closest('a[data-bq-sugerida]');
      if (!s || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0) return;
      const { input, estado, caja } = partes();
      if (!input || !caja) return;
      e.preventDefault();
      input.value = s.dataset.bqSugerida;
      clearTimeout(espera);
      buscar({ forzar: true, alFallar: true }).then(() => {
        const { estado: est } = partes();
        if (est) est.focus({ preventScroll: true });
        const reducir = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        window.scrollTo({ top: 0, behavior: reducir ? 'auto' : 'smooth' });
      });
    });

    const iniciar = () => {
      copiarEstado();
      const { form } = partes();
      if (form) ultima = urlDe(form);
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar);
    else iniciar();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["busqueda-resultados"]) return;
  try {
    
  /* Ver por sección: filtra en el navegador las piezas de esta página. Delegado: sobrevive cuando el campo cambia la sección. */
  (() => {
    document.addEventListener('click', e => {
      const b = e.target.closest && e.target.closest('[data-bq-seccion]');
      if (!b) return;
      const caja = b.closest('[data-bq-resultados]');
      if (!caja) return;
      const s = b.dataset.bqSeccion;
      let vistas = 0;
      caja.querySelectorAll('[data-bq-pieza]').forEach(li => {
        const ve = s === 'todo' || (li.dataset.secciones || '').split(' ').includes(s);
        li.hidden = !ve;
        if (ve) vistas++;
      });
      caja.querySelectorAll('[data-bq-seccion]').forEach(x => x.setAttribute('aria-pressed', String(x === b)));
      const vacio = caja.querySelector('[data-bq-filtro-vacio]');
      if (vacio) vacio.hidden = vistas > 0;
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["carrito-combina"]) return;
  try {
    
  /* Combina con, en el carrito: agrega sin abrir el cajón y avisa de dónde llega */
  (() => {
    'use strict';
    const fmt = (t, v) => String(t).replace(/\{(\w+)\}/g, (m, k) => (k in v ? v[k] : m));
    document.addEventListener('click', e => {
      const b = e.target.closest('[data-combina-agregar]');
      if (!b || !window.Patio || !window.Patio.carrito) return;
      const li = b.closest('[data-combina-producto]');
      const sec = b.closest('[data-bolsa-combina]');
      if (!li || !sec || b.getAttribute('aria-busy') === 'true') return;
      const error = li.querySelector('[data-combina-error]');
      const d = li.dataset;
      const mensaje = fmt(d.ciudad ? sec.dataset.msjCiudad : sec.dataset.msj, { nombre: d.nombre, ciudad: d.ciudad });
      b.setAttribute('aria-busy', 'true');
      if (error) error.textContent = '';
      window.Patio.carrito.agregar(b.dataset.combinaAgregar, 1, {}, { abrir: false, mensaje })
        .then(() => { const ya = li.querySelector('[data-combina-ya]'); if (ya) ya.hidden = false; })
        .catch(err => { if (error) error.textContent = err.message; })
        .finally(() => b.removeAttribute('aria-busy'));
    });
    /* Con el carrito vacío no tiene caso; si vuelve a tener piezas, regresa */
    document.addEventListener('patio:carrito-actualizado', e => {
      const sec = document.querySelector('[data-bolsa-combina]');
      if (!sec || !e.detail) return;
      sec.hidden = !e.detail.item_count;
      const ids = new Set((e.detail.items || []).map(i => String(i.product_id)));
      sec.querySelectorAll('[data-combina-producto]').forEach(li => {
        const ya = li.querySelector('[data-combina-ya]');
        if (ya) ya.hidden = !ids.has(li.dataset.combinaProducto);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["carrito-principal"]) return;
  try {
    
  /* Carrito: cantidades y quitar sin recargar; la página se repinta con la Section Rendering API */
  (() => {
    'use strict';
    const raiz = () => document.querySelector('[data-bolsa]');
    const fmt = (t, v) => String(t).replace(/\{(\w+)\}/g, (m, k) => (k in v ? v[k] : m));
    let pendiente = null;
    let ocupado = false;

    /* Pide esta sección y cambia lo que hay */
    const repintar = async () => {
      const r = raiz();
      if (!r) return;
      const id = r.dataset.bolsa;
      const res = await fetch(window.location.pathname + '?sections=' + encodeURIComponent(id), { headers: { Accept: 'application/json' } });
      if (!res.ok) return;
      const datos = await res.json();
      if (!datos[id]) return;
      const doc = new DOMParser().parseFromString(datos[id], 'text/html');
      const nuevo = doc.querySelector('[data-bolsa]');
      const viejo = raiz();
      if (viejo && nuevo) viejo.replaceWith(document.importNode(nuevo, true));
      pintarFavs();
    };

    /* Vacío: cuántas piezas hay en favoritos */
    const pintarFavs = () => {
      const p = document.querySelector('[data-bolsa-favs]');
      if (!p || !window.Patio || !window.Patio.favoritos) return;
      const n = window.Patio.favoritos.lista().length;
      p.hidden = !n;
      const s = p.querySelector('[data-bolsa-favs-n]');
      if (s) s.textContent = fmt(n === 1 ? p.dataset.una : p.dataset.varias, { n });
    };

    document.addEventListener('patio:carrito-actualizado', () => {
      if (!raiz()) return;
      pendiente = repintar().catch(() => {});
    });
    document.addEventListener('patio:favoritos-actualizados', pintarFavs);
    document.addEventListener('patio:listo', pintarFavs);

    document.addEventListener('click', async e => {
      const b = e.target.closest('[data-bolsa] [data-bolsa-cambiar]');
      if (!b || !window.Patio || !window.Patio.carrito) return;
      e.preventDefault();
      if (ocupado || b.getAttribute('aria-disabled') === 'true') return;
      const clave = b.dataset.linea;
      const accion = b.dataset.accion;
      const n = Number(b.dataset.cantidad) || 0;
      const nombre = b.dataset.nombre || '';
      const r = raiz();
      const grid = r && r.querySelector('[data-bolsa-form]');
      /* A dónde va el foco si la línea se va: la siguiente o la anterior */
      const quitares = [...r.querySelectorAll('[data-accion="quitar"]')];
      const i = quitares.findIndex(q => q.dataset.linea === clave);
      const vecina = (quitares[i + 1] || quitares[i - 1] || {}).dataset;
      ocupado = true;
      if (grid) grid.setAttribute('aria-busy', 'true');
      try {
        await window.Patio.carrito.cambiar(clave, n);
        if (pendiente) await pendiente;
        const t = window.patioTema && window.patioTema.textos;
        if (t) window.Patio.avisar(fmt(n === 0 ? t.quitado : t.cantidad, { nombre, n }));
        const nr = raiz();
        const igual = nr && nr.querySelector('[data-linea="' + CSS.escape(clave) + '"][data-accion="' + accion + '"]');
        if (n > 0 && igual) igual.focus();
        else if (vecina && nr && nr.querySelector('[data-linea="' + CSS.escape(vecina.linea) + '"][data-accion="quitar"]')) nr.querySelector('[data-linea="' + CSS.escape(vecina.linea) + '"][data-accion="quitar"]').focus();
        else if (nr) nr.querySelector('[data-bolsa-titulo]').focus();
      } catch (err) {
        const nr = raiz();
        const aviso = nr && nr.querySelector('[data-bolsa-aviso]');
        if (aviso) aviso.textContent = err.message;
        if (grid) grid.removeAttribute('aria-busy');
      } finally {
        ocupado = false;
      }
    });

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', pintarFavs);
    else pintarFavs();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["coleccion-piezas"]) return;
  try {
    
  /* Filtros de la colección: Section Rendering API, sin recargar. Sin JS, el formulario se manda normal. */
  (() => {
    const escritorio = window.matchMedia('(min-width: 1024px)');
    const quieto = window.matchMedia('(prefers-reduced-motion: reduce)');
    let control = null;

    const parte = (raiz, k) => raiz && raiz.querySelector('[data-parte="' + k + '"]');
    const seccionDe = el => el && el.closest('[data-col-seccion]');

    const urlDe = form => {
      const p = new URLSearchParams();
      for (const [k, v] of new FormData(form)) {
        const valor = String(v).trim();
        if (k === 'precio' || valor === '') continue;
        if (k === 'sort_by' && valor === form.dataset.orden) continue;
        p.append(k, valor);
      }
      const s = p.toString();
      return form.action.split('?')[0] + (s ? '?' + s : '');
    };

    const traer = async (url, sid) => {
      if (control) control.abort();
      control = new AbortController();
      const u = new URL(url, window.location.href);
      u.searchParams.set('section_id', sid);
      const r = await fetch(u.toString(), { signal: control.signal, credentials: 'same-origin' });
      if (!r.ok) throw new Error('HTTP ' + r.status);
      return new DOMParser().parseFromString(await r.text(), 'text/html');
    };

    const ponerPanel = (form, abierto) => {
      const b = form && form.querySelector('[data-col-abrir]');
      const p = form && form.querySelector('.col-filtros__panel');
      if (!b || !p) return;
      b.setAttribute('aria-expanded', String(abierto));
      p.dataset.open = String(abierto);
    };

    const focoDeRespaldo = form => {
      const chip = form.querySelector('[data-parte="chips"] a');
      const destino = chip || (escritorio.matches ? form.querySelector('summary') : form.querySelector('[data-col-abrir]'));
      if (destino) destino.focus({ preventScroll: true });
    };

    const pintar = (sec, doc) => {
      const form = sec.querySelector('[data-col-filtros]');
      const nueva = doc.querySelector('[data-col-seccion]');
      if (!form || !nueva) return false;
      const abiertos = [...form.querySelectorAll('details[open]')].map(d => d.dataset.grupo);
      const a = document.activeElement;
      const foco = a && form.contains(a) && a.name ? { name: a.name, value: a.value, tipo: a.type } : null;

      ['abrir-n', 'inner', 'chips'].forEach(k => {
        const viejo = parte(sec, k);
        const nuevo = parte(nueva, k);
        if (viejo && nuevo) viejo.innerHTML = nuevo.innerHTML;
      });
      const e1 = parte(sec, 'estado');
      const e2 = parte(nueva, 'estado');
      if (e1 && e2 && e1.textContent !== e2.textContent) e1.textContent = e2.textContent;
      const l1 = parte(sec, 'lista');
      const l2 = parte(nueva, 'lista');
      if (l1 && l2) l1.replaceWith(document.importNode(l2, true));

      abiertos.forEach(g => {
        const d = form.querySelector('details[data-grupo="' + CSS.escape(g) + '"]');
        if (d) d.open = true;
      });
      if (foco) {
        const nombre = '[name="' + CSS.escape(foco.name) + '"]';
        const el = (foco.tipo === 'checkbox' || foco.tipo === 'radio')
          ? form.querySelector(nombre + '[value="' + CSS.escape(foco.value) + '"]')
          : form.querySelector(nombre);
        if (el) el.focus({ preventScroll: true });
      }
      return true;
    };

    const aplicar = async (sec, url, opciones = {}) => {
      if (!sec) return;
      const form = sec.querySelector('[data-col-filtros]');
      const lista = parte(sec, 'lista');
      const antes = document.activeElement;
      if (lista) lista.setAttribute('aria-busy', 'true');
      try {
        const doc = await traer(url, sec.dataset.colSeccion);
        if (!pintar(sec, doc)) throw new Error('sin sección');
        if (opciones.empujar !== false) history.pushState({ patioColeccion: true }, '', url);
        const ahora = document.activeElement;
        if (form && antes && !document.contains(antes) && (!ahora || ahora === document.body)) focoDeRespaldo(form);
      } catch (e) {
        if (e && e.name === 'AbortError') return;
        window.location.href = url;
      }
    };

    const verMas = async enlace => {
      const sec = seccionDe(enlace);
      const rejilla = sec && sec.querySelector('.col-rejilla');
      if (!rejilla) { window.location.href = enlace.href; return; }
      enlace.setAttribute('aria-disabled', 'true');
      try {
        const doc = await traer(enlace.href, sec.dataset.colSeccion);
        const desde = rejilla.children.length;
        doc.querySelectorAll('.col-rejilla > li').forEach(li => rejilla.appendChild(document.importNode(li, true)));
        const m1 = parte(sec, 'mas');
        const m2 = doc.querySelector('[data-parte="mas"]');
        if (m1 && m2) m1.replaceWith(document.importNode(m2, true));
        const e1 = parte(sec, 'estado');
        const e2 = doc.querySelector('[data-parte="estado"]');
        if (e1 && e2) e1.textContent = e2.textContent;
        const primera = rejilla.children[desde];
        const liga = primera && primera.querySelector('.pieza__nombre a, a');
        if (liga) liga.focus({ preventScroll: true });
        if (primera) primera.scrollIntoView({ block: 'nearest', behavior: quieto.matches ? 'auto' : 'smooth' });
      } catch (e) {
        if (e && e.name === 'AbortError') { enlace.removeAttribute('aria-disabled'); return; }
        window.location.href = enlace.href;
      }
    };

    document.addEventListener('change', e => {
      const form = e.target.closest && e.target.closest('[data-col-filtros]');
      if (!form) return;
      const t = e.target;
      if (t.name === 'precio') {
        const min = form.querySelector('[data-precio-min]');
        const max = form.querySelector('[data-precio-max]');
        if (min) min.value = t.dataset.min || '';
        if (max) max.value = t.dataset.max || '';
      }
      aplicar(seccionDe(form), urlDe(form));
    });

    document.addEventListener('submit', e => {
      const form = e.target.closest && e.target.closest('[data-col-filtros]');
      if (!form) return;
      e.preventDefault();
      const sec = seccionDe(form);
      if (e.submitter && e.submitter.hasAttribute('data-col-listo')) {
        ponerPanel(form, false);
        const b = form.querySelector('[data-col-abrir]');
        const lista = parte(sec, 'lista');
        if (lista) lista.scrollIntoView({ block: 'start', behavior: quieto.matches ? 'auto' : 'smooth' });
        if (b) b.focus({ preventScroll: true });
        return;
      }
      aplicar(sec, urlDe(form));
    });

    document.addEventListener('click', e => {
      if (!e.target.closest) return;
      const abrir = e.target.closest('[data-col-abrir]');
      if (abrir) {
        ponerPanel(abrir.closest('[data-col-filtros]'), abrir.getAttribute('aria-expanded') !== 'true');
        return;
      }
      const liga = e.target.closest('a[data-col-ajax], a[data-col-mas]');
      if (!liga || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0) return;
      e.preventDefault();
      if (liga.hasAttribute('data-col-mas')) { verMas(liga); return; }
      aplicar(seccionDe(liga), liga.href);
    });

    /* Escritorio: cada grupo es un menú que baja; solo uno abierto a la vez */
    document.addEventListener('toggle', e => {
      const d = e.target;
      if (!d.matches || !d.matches('[data-col-filtros] details') || !d.open || !escritorio.matches) return;
      d.closest('[data-col-filtros]').querySelectorAll('details[open]').forEach(o => { if (o !== d) o.open = false; });
    }, true);
    document.addEventListener('pointerdown', e => {
      if (!escritorio.matches) return;
      document.querySelectorAll('[data-col-filtros] details[open]').forEach(d => { if (!d.contains(e.target)) d.open = false; });
    });
    document.addEventListener('keydown', e => {
      if (e.key !== 'Escape' || !escritorio.matches) return;
      const d = document.querySelector('[data-col-filtros] details[open]');
      if (!d) return;
      const dentro = d.contains(document.activeElement);
      d.open = false;
      if (dentro) d.querySelector('summary').focus();
    });
    escritorio.addEventListener('change', () => {
      document.querySelectorAll('[data-col-filtros]').forEach(form => {
        form.querySelectorAll('details[open]').forEach(d => { d.open = false; });
        ponerPanel(form, false);
      });
    });

    /* Atrás y adelante del navegador */
    window.addEventListener('popstate', e => {
      if (!e.state || !e.state.patioColeccion) return;
      const sec = document.querySelector('[data-col-seccion]');
      if (sec) aplicar(sec, window.location.href, { empujar: false });
    });
    const marcar = () => {
      if (document.querySelector('[data-col-seccion]') && !(history.state && history.state.patioColeccion)) {
        try { history.replaceState({ patioColeccion: true }, ''); } catch (e) { /* sin historial */ }
      }
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', marcar);
    else marcar();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["directorio-marcas"] && !Shopify.designMode) return;
  try {
    
  /* Directorio: filtra lo que ya está en la página, sin recargar. La URL guarda lo escogido. */
  (() => {
    const iniciar = (raiz) => {
      const form = raiz && raiz.querySelector('[data-filtros]');
      if (!form || form.dataset.listo) return;
      form.dataset.listo = '1';

      let T = {};
      try { T = JSON.parse(raiz.querySelector('[data-textos]').textContent); } catch (e) {}
      const select = form.querySelector('select');
      const caja = select ? select.closest('.dr-ciudad') : null;
      const filas = [...raiz.querySelectorAll('.dr-fila')];
      const letras = [...raiz.querySelectorAll('.dr-letra')];
      const estado = form.querySelector('[data-estado]');
      const resumen = estado.textContent;
      const verTodas = form.querySelector('[data-ver-todas]');
      const vacio = raiz.querySelector('[data-vacio]');
      const vacioTexto = vacio.querySelector('[data-vacio-texto]');
      const otraCiudad = vacio.querySelector('[data-todas-ciudades]');
      const cols = raiz.querySelector('.dr-cols');

      const nombres = {};
      if (select) [...select.options].forEach(o => { if (o.value) nombres[o.value] = o.dataset.nombre || o.textContent; });

      const valorCat = () => { const r = form.querySelector('input[name="cat"]:checked'); return r ? r.value : ''; };
      const valorCiudad = () => select ? select.value : '';
      const pasa = (li, cat, ciudad) =>
        (!cat || (li.dataset.cat || '').split(' ').includes(cat)) && (!ciudad || li.dataset.ciudad === ciudad);
      const cuenta = n => n === 0 ? T.ninguna : n === 1 ? T.una : String(T.varias).replace('[n]', n);

      const aplicar = () => {
        const cat = valorCat(), ciudad = valorCiudad();
        let n = 0;
        for (const li of filas) { const ok = pasa(li, cat, ciudad); li.hidden = !ok; if (ok) n++; }
        for (const l of letras) l.hidden = !l.querySelector('.dr-fila:not([hidden])');

        /* Cuántas hay en cada opción, con lo otro que ya escogiste */
        form.querySelectorAll('input[name="cat"]').forEach(i => {
          const c = filas.filter(li => pasa(li, i.value, ciudad)).length;
          const op = i.closest('.dr-op');
          op.querySelector('[data-n]').textContent = c;
          op.classList.toggle('dr-op--cero', c === 0);
        });
        if (select) {
          const conCiudad = new Set(filas.filter(li => pasa(li, cat, '')).map(li => li.dataset.ciudad).filter(Boolean));
          [...select.options].forEach(o => {
            if (!o.value) { o.textContent = T.todas + ' (' + conCiudad.size + ')'; return; }
            o.textContent = nombres[o.value] + ' (' + filas.filter(li => pasa(li, cat, o.value)).length + ')';
          });
          caja.toggleAttribute('data-activa', ciudad !== '');
        }

        const filtrado = cat !== '' || ciudad !== '';
        const donde = ciudad ? String(T.en).replace('[ciudad]', nombres[ciudad] || '') : '';
        const frase = [(T.cat || {})[cat], donde].filter(Boolean).join(' ');
        estado.textContent = filtrado ? cuenta(n) + ' ' + frase : resumen;
        verTodas.hidden = !filtrado;
        vacio.hidden = n !== 0;
        if (cols) cols.hidden = n === 0;
        if (!n) vacioTexto.textContent = String(T.vacio).replace('[frase]', frase);
        if (otraCiudad) otraCiudad.hidden = !ciudad;

        try {
          const u = new URL(location.href);
          cat ? u.searchParams.set('cat', cat) : u.searchParams.delete('cat');
          ciudad ? u.searchParams.set('ciudad', ciudad) : u.searchParams.delete('ciudad');
          const nueva = u.pathname + u.search + u.hash;
          if (nueva !== location.pathname + location.search + location.hash) history.replaceState(history.state, '', nueva);
        } catch (e) {}
      };

      const poner = (cat, ciudad) => {
        const r = [...form.querySelectorAll('input[name="cat"]')].find(i => i.value === cat);
        if (r) r.checked = true;
        if (select && [...select.options].some(o => o.value === ciudad)) select.value = ciudad;
      };
      try {
        const q = new URLSearchParams(location.search);
        poner(q.get('cat') || '', q.get('ciudad') || '');
      } catch (e) {}

      form.addEventListener('change', aplicar);
      form.addEventListener('submit', e => e.preventDefault());
      verTodas.addEventListener('click', () => {
        poner('', '');
        if (select) select.value = '';
        aplicar();
        const r = form.querySelector('input[name="cat"]:checked');
        if (r) r.focus();
      });
      if (otraCiudad) otraCiudad.addEventListener('click', () => {
        if (select) select.value = '';
        aplicar();
        if (select) select.focus();
      });
      aplicar();
    };

    const todo = () => document.querySelectorAll('[data-directorio]').forEach(iniciar);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', todo);
    else todo();
    document.addEventListener('shopify:section:load', e => {
      e.target.querySelectorAll('[data-directorio]').forEach(iniciar);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["edicion-boletin"]) return;
  try {
    
  /* El correo del jueves: revisa el correo antes de mandarlo y, al volver de Shopify, lleva el foco a la confirmación */
  (() => {
    document.addEventListener('submit', e => {
      const form = e.target.closest && e.target.closest('[data-ed-boletin]');
      if (!form) return;
      const campo = form.querySelector('input[type="email"]');
      const estado = form.querySelector('[data-ed-estado]');
      if (!campo) return;
      const v = campo.value.trim();
      campo.value = v;
      if (!v || !campo.checkValidity()) {
        e.preventDefault();
        campo.setAttribute('aria-invalid', 'true');
        if (estado) estado.textContent = (v ? estado.dataset.error : estado.dataset.vacio) || '';
        campo.focus();
      }
    });
    document.addEventListener('input', e => {
      const campo = e.target;
      if (!campo.matches || !campo.matches('[data-ed-boletin] input[type="email"]')) return;
      if (campo.getAttribute('aria-invalid') === 'true' && campo.checkValidity()) {
        campo.removeAttribute('aria-invalid');
        const estado = campo.form && campo.form.querySelector('[data-ed-estado]');
        if (estado) estado.textContent = '';
      }
    });
    const enfocar = () => {
      const listo = document.querySelector('[data-ed-listo]');
      if (listo) listo.focus({ preventScroll: false });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', enfocar);
    else enfocar();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["favoritos-lista"]) return;
  try {
    
  /* Favoritos: pide cada pieza a Shopify, las agrupa por marca y deja quitar, deshacer y agregar */
  (() => {
    'use strict';
    const fmt = (t, v) => String(t).replace(/\{(\w+)\}/g, (m, k) => (k in v ? v[k] : m));
    const listo = () => new Promise(res => {
      if (window.Patio && window.Patio.favoritos && document.documentElement.dataset.patio === 'listo') res();
      else document.addEventListener('patio:listo', () => res(), { once: true });
    });

    const iniciar = async raiz => {
      if (!raiz || raiz.dataset.favsListo) return;
      raiz.dataset.favsListo = '1';
      await listo();
      const P = window.Patio;
      let T = {};
      try { T = JSON.parse(raiz.querySelector('[data-favs-textos]').textContent); } catch (e) { /* textos de respaldo vacíos */ }
      const base = raiz.dataset.raiz || '/';
      const grupos = raiz.querySelector('[data-favs-grupos]');
      const vacio = raiz.querySelector('[data-favs-vacio]');
      const cargando = raiz.querySelector('[data-favs-cargando]');
      const deshacer = raiz.querySelector('[data-favs-deshacer]');
      const deshacerTxt = raiz.querySelector('[data-favs-deshacer-txt]');
      const cuenta = document.querySelector('[data-favs-cuenta]');
      const bajada = document.querySelector('[data-favs-bajada]');

      const cache = new Map();
      /* Lo más reciente arriba; mientras estás aquí, cada pieza conserva su lugar aunque la quites y la regreses */
      const orden = P.favoritos.lista().slice().reverse();
      let actuales = new Set(P.favoritos.lista());
      let enCarrito = new Set();
      let ultimo = null;

      const piezasTxt = n => (n === 1 ? T.unaPieza : fmt(T.piezas, { n }));
      const marcasTxt = n => (n === 1 ? T.unaMarca : fmt(T.marcas, { n }));
      const nombreDe = h => {
        const el = cache.get(h);
        if (el && el.dataset && el.dataset.nombre) return el.dataset.nombre;
        return h.replace(/-/g, ' ').replace(/^./, c => c.toUpperCase());
      };

      /* ---- Traer cada pieza: seis a la vez ---- */
      const traer = async h => {
        try {
          const r = await fetch(base + 'products/' + encodeURIComponent(h) + '?section_id=favoritos-pieza', { headers: { Accept: 'text/html' } });
          if (!r.ok) return null;
          const doc = new DOMParser().parseFromString(await r.text(), 'text/html');
          return doc.querySelector('[data-favs-pieza]');
        } catch (e) {
          return null;
        }
      };
      const traerTodas = async lista => {
        const cola = lista.filter(h => !cache.has(h));
        const obreros = Array.from({ length: Math.min(6, cola.length) }, async () => {
          while (cola.length) {
            const h = cola.shift();
            cache.set(h, (await traer(h)) || 'perdida');
          }
        });
        await Promise.all(obreros);
      };
      const leerCarrito = async () => {
        try {
          const r = await fetch(base + 'cart.js', { headers: { Accept: 'application/json' } });
          const c = await r.json();
          enCarrito = new Set((c.items || []).map(i => String(i.product_id)));
        } catch (e) { /* sin carrito: no se marca nada */ }
      };

      /* ---- Pintar ---- */
      const perdida = h => {
        const li = document.createElement('li');
        li.className = 'pieza favs-pieza favs-pieza--perdida';
        li.dataset.favsPieza = h;
        li.dataset.marca = '';
        const foto = document.createElement('div');
        foto.className = 'pieza__foto';
        foto.textContent = T.perdida;
        const info = document.createElement('div');
        info.className = 'favs-pieza__info';
        const nom = document.createElement('h3');
        nom.className = 'pieza__nombre';
        nom.textContent = nombreDe(h);
        info.append(nom);
        const acc = document.createElement('div');
        acc.className = 'favs-pieza__acciones';
        const q = document.createElement('button');
        q.type = 'button';
        q.className = 'favs-pieza__quitar';
        q.dataset.favsQuitar = '';
        q.textContent = T.quitar;
        const sr = document.createElement('span');
        sr.className = 'sr-only';
        sr.textContent = ' ' + fmt(T.quitarSr, { nombre: nombreDe(h) });
        q.append(sr);
        acc.append(q);
        li.append(foto, info, acc);
        return li;
      };
      const tarjeta = h => {
        const el = cache.get(h);
        const t = el && el.cloneNode ? document.importNode(el, true) : perdida(h);
        const ya = t.querySelector('[data-favs-ya]');
        if (ya) ya.hidden = !enCarrito.has(t.dataset.producto);
        return t;
      };
      const pintar = () => {
        const ids = orden.filter(h => actuales.has(h));
        vacio.hidden = ids.length > 0;
        if (bajada) bajada.hidden = !ids.length;
        if (!ids.length) {
          grupos.replaceChildren();
          if (cuenta) cuenta.textContent = T.ninguna;
          return;
        }
        const marcas = [];
        const por = new Map();
        ids.forEach(h => {
          const el = cache.get(h);
          const m = (el && el.dataset && el.dataset.marca) || '';
          if (!por.has(m)) { por.set(m, []); marcas.push(m); }
          por.get(m).push(h);
        });
        const secciones = marcas.map((m, i) => {
          const suyas = por.get(m);
          const muestra = cache.get(suyas[0]);
          const d = (muestra && muestra.dataset) || {};
          const k = suyas.length;
          const sec = document.createElement('section');
          sec.className = 'favs-grupo';
          sec.setAttribute('aria-labelledby', 'favs-g-' + i);
          sec.style.cssText = '--n2: ' + Math.min(k, 2) + '; --n3: ' + Math.min(k, 3) + '; --n4: ' + Math.min(k, 4);
          const cab = document.createElement('header');
          cab.className = 'favs-grupo__cabeza';
          const h2 = document.createElement('h2');
          h2.className = 'display favs-grupo__marca';
          h2.id = 'favs-g-' + i;
          const lugar = document.createElement('p');
          lugar.className = 'favs-grupo__lugar';
          if (m && d.marcaNombre) {
            if (d.marcaUrl) {
              const a = document.createElement('a');
              a.href = d.marcaUrl;
              a.textContent = d.marcaNombre;
              h2.append(a);
            } else h2.textContent = d.marcaNombre;
            lugar.textContent = d.ciudad ? fmt(T.desde, { ciudad: d.ciudad }) + ' · ' + piezasTxt(k) : piezasTxt(k);
          } else {
            h2.textContent = T.otras;
            lugar.textContent = piezasTxt(k);
          }
          cab.append(h2, lugar);
          const ul = document.createElement('ul');
          ul.className = 'favs-grupo__piezas';
          ul.setAttribute('role', 'list');
          ul.append(...suyas.map(tarjeta));
          sec.append(cab, ul);
          return sec;
        });
        grupos.replaceChildren(...secciones);
        const conMarca = marcas.filter(Boolean).length;
        if (cuenta) cuenta.textContent = piezasTxt(ids.length) + (conMarca ? ' ' + fmt(T.deMarcas, { marcas: marcasTxt(conMarca) }) : '');
      };
      const tarjetaDe = h => [...grupos.querySelectorAll('[data-favs-pieza]')].find(el => el.dataset.favsPieza === h);

      /* ---- Quitar y deshacer: siempre por Patio.favoritos ---- */
      const mostrarDeshacer = (h, foco) => {
        deshacerTxt.textContent = fmt(T.quitaste, { nombre: nombreDe(h) });
        deshacer.hidden = false;
        if (foco) deshacer.querySelector('button').focus();
      };
      document.addEventListener('patio:favoritos-actualizados', async e => {
        if (!document.contains(raiz)) return;
        const { handle, guardado } = e.detail || {};
        const estaba = handle ? actuales.has(handle) : false;
        const foco = raiz.contains(document.activeElement) || document.activeElement === document.body;
        actuales = new Set(P.favoritos.lista());
        if (handle && guardado && !orden.includes(handle)) orden.unshift(handle);
        if (!handle) P.favoritos.lista().forEach(h => { if (!orden.includes(h)) orden.unshift(h); });
        const faltan = [...actuales].filter(h => !cache.has(h));
        if (faltan.length) await traerTodas(faltan);
        pintar();
        if (handle && estaba && !guardado) {
          ultimo = handle;
          mostrarDeshacer(handle, foco);
        } else if (handle && guardado) {
          deshacer.hidden = true;
          const t = tarjetaDe(handle);
          const a = t && t.querySelector('.pieza__nombre a');
          if (a && foco) a.focus();
          if (ultimo === handle) P.avisar(fmt(T.volvio, { nombre: nombreDe(handle) }));
          ultimo = null;
        }
        if (!actuales.size) {
          deshacer.hidden = !ultimo;
        }
      });
      deshacer.addEventListener('click', e => {
        if (!e.target.closest('[data-favs-deshacer-btn]') || !ultimo) return;
        P.favoritos.alternar(ultimo);
      });

      /* ---- Agregar al carrito y escoger opciones ---- */
      const variantesDe = card => {
        try { return JSON.parse(card.querySelector('[data-favs-variantes]').textContent); } catch (e) { return []; }
      };
      const elegidos = card => [...card.querySelectorAll('[data-favs-grupo]')].map(fs => {
        const b = fs.querySelector('[aria-pressed="true"]');
        return b ? b.dataset.favsElige : null;
      });
      const pintarOpciones = card => {
        const vs = variantesDe(card);
        const sel = elegidos(card);
        const n = sel.length;
        card.querySelectorAll('[data-favs-valor]').forEach(b => {
          const v = vs.find(x => x.options[n] === b.dataset.favsValor && sel.every((s, j) => s == null || x.options[j] === s));
          const si = !!(v && v.available);
          b.disabled = !si;
          b.dataset.variante = v ? v.id : '';
          if (si) b.removeAttribute('aria-label');
          else b.setAttribute('aria-label', fmt(T.valorAgotado, { valor: b.dataset.favsValor }));
        });
      };
      const cerrarOpciones = (card, enfocar) => {
        const caja = card.querySelector('[data-favs-opciones]');
        const a = card.querySelector('[data-favs-abrir]');
        if (caja) caja.hidden = true;
        if (a) { a.setAttribute('aria-expanded', 'false'); if (enfocar) a.focus(); }
      };
      const agregar = (card, id, desde, valor) => {
        if (!id) return;
        const d = card.dataset;
        const nombre = nombreDe(d.favsPieza) + (valor ? ', ' + (d.esTalla === 'true' ? T.talla + ' ' + valor : valor) : '');
        const marca = d.marcaNombre || '';
        const ciudad = d.ciudad || '';
        let mensaje;
        if (marca) mensaje = ciudad ? fmt(T.agregadoCiudad, { nombre, marca, ciudad }) : fmt(T.agregado, { nombre, marca });
        const error = card.querySelector('[data-favs-error]');
        const principal = card.querySelector('[data-favs-abrir], [data-favs-agregar]');
        if (error) error.textContent = '';
        if (principal) principal.setAttribute('aria-busy', 'true');
        P.carrito.agregar(id, 1, {}, { desde: principal || desde, mensaje })
          .then(() => cerrarOpciones(card, false))
          .catch(err => { if (error) error.textContent = err.message; })
          .finally(() => { if (principal) principal.removeAttribute('aria-busy'); });
      };
      grupos.addEventListener('click', e => {
        const card = e.target.closest('[data-favs-pieza]');
        if (!card) return;
        const q = e.target.closest('[data-favs-quitar]');
        if (q) {
          if (P.favoritos.tiene(card.dataset.favsPieza)) P.favoritos.alternar(card.dataset.favsPieza);
          else { actuales.delete(card.dataset.favsPieza); pintar(); }
          return;
        }
        const directo = e.target.closest('[data-favs-agregar]');
        if (directo) { agregar(card, directo.dataset.favsAgregar, directo); return; }
        const abrir = e.target.closest('[data-favs-abrir]');
        if (abrir) {
          const caja = card.querySelector('[data-favs-opciones]');
          const ver = caja.hidden;
          caja.hidden = !ver;
          abrir.setAttribute('aria-expanded', String(ver));
          if (ver) {
            pintarOpciones(card);
            const primera = caja.querySelector('[data-favs-valor]:not(:disabled)');
            if (primera) primera.focus();
          }
          return;
        }
        const elige = e.target.closest('[data-favs-elige]');
        if (elige) {
          elige.closest('[data-favs-grupo]').querySelectorAll('[data-favs-elige]').forEach(b => b.setAttribute('aria-pressed', String(b === elige)));
          pintarOpciones(card);
          return;
        }
        const valor = e.target.closest('[data-favs-valor]');
        if (valor && !valor.disabled) agregar(card, valor.dataset.variante, valor, valor.dataset.favsValor);
      });
      /* Escape cierra las opciones y regresa al botón */
      grupos.addEventListener('keydown', e => {
        if (e.key !== 'Escape') return;
        const caja = e.target.closest('[data-favs-opciones]');
        if (!caja) return;
        e.stopPropagation();
        cerrarOpciones(caja.closest('[data-favs-pieza]'), true);
      });
      document.addEventListener('patio:carrito-actualizado', e => {
        if (!e.detail || !document.contains(raiz)) return;
        enCarrito = new Set((e.detail.items || []).map(i => String(i.product_id)));
        grupos.querySelectorAll('[data-favs-pieza]').forEach(t => {
          const ya = t.querySelector('[data-favs-ya]');
          if (ya) ya.hidden = !enCarrito.has(t.dataset.producto);
        });
      });

      /* ---- Primera vez ---- */
      if (!orden.length) { pintar(); return; }
      cargando.hidden = false;
      grupos.setAttribute('aria-busy', 'true');
      await Promise.all([traerTodas(orden), leerCarrito()]);
      cargando.hidden = true;
      grupos.removeAttribute('aria-busy');
      pintar();
    };

    const todas = (c = document) => c.querySelectorAll('[data-favs]').forEach(iniciar);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => todas());
    else todas();
    document.addEventListener('shopify:section:load', e => todas(e.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["inicio-boletin"] && !Shopify.designMode) return;
  try {
    
  /* Boletín: si el correo no se ve completo, se avisa junto al campo y no se manda */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.classList || !form.classList.contains('ini-boletin__form')) return;
    var campo = form.querySelector('input[type="email"]');
    var estado = form.querySelector('.ini-boletin__estado');
    if (!campo) return;
    if (!campo.value.trim() || !campo.checkValidity()) {
      e.preventDefault();
      campo.setAttribute('aria-invalid', 'true');
      if (estado) estado.textContent = estado.getAttribute('data-error') || '';
      campo.focus();
      return;
    }
    campo.removeAttribute('aria-invalid');
    if (estado) estado.textContent = '';
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["producto-combina"]) return;
  try {
    
  /* Combina con: recomendaciones de Shopify, de otras marcas cuando se puede */
  (() => {
    'use strict';
    const pedir = async (url, intent) => {
      try {
        const r = await fetch(url + '&intent=' + intent, { headers: { Accept: 'text/html' } });
        if (!r.ok) return [];
        const doc = new DOMParser().parseFromString(await r.text(), 'text/html');
        return [...doc.querySelectorAll('[data-combina-item]')];
      } catch (e) {
        return [];
      }
    };
    const cargar = async sec => {
      if (!sec || sec.dataset.combinaLista || !sec.dataset.url) return;
      sec.dataset.combinaLista = '1';
      const n = Number(sec.dataset.cantidad) || 4;
      let items = await pedir(sec.dataset.url, 'complementary');
      if (!items.length) items = await pedir(sec.dataset.url, 'related');
      if (!items.length) return;
      const otras = items.filter(i => i.dataset.marca !== sec.dataset.marca);
      const misma = items.filter(i => i.dataset.marca === sec.dataset.marca);
      const elegidas = otras.slice(0, n);
      if (elegidas.length < n) elegidas.push(...misma.slice(0, n - elegidas.length));
      if (!elegidas.length) return;
      const lista = sec.querySelector('[data-combina-lista]');
      const texto = sec.querySelector('[data-combina-texto]');
      if (texto && elegidas.some(i => i.dataset.marca === sec.dataset.marca) && texto.dataset.mixto) texto.textContent = texto.dataset.mixto;
      lista.replaceChildren(...elegidas.map(i => document.importNode(i, true)));
      sec.hidden = false;
    };
    const todas = (c = document) => c.querySelectorAll('[data-ficha-combina]').forEach(cargar);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => todas());
    else todas();
    document.addEventListener('shopify:section:load', e => todas(e.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["producto-principal"]) return;
  try {
    
  /* Ficha de producto: galería, opciones, precio, URL, agregar al carrito y barra fija */
  (() => {
    'use strict';
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
    const telefono = window.matchMedia('(max-width: 1023.98px)');
    const fmt = (t, v) => String(t).replace(/\{(\w+)\}/g, (m, k) => (k in v ? v[k] : m));
    const dinero = c => {
      if (window.Patio && window.Patio.dinero) return window.Patio.dinero(c);
      const n = Number(c) / 100;
      return '$' + n.toLocaleString('en-US', { minimumFractionDigits: n % 1 ? 2 : 0, maximumFractionDigits: 2 });
    };
    const juntar = (a, y) => (a.length < 2 ? a.join('') : a.slice(0, -1).join(', ') + ' ' + y + ' ' + a[a.length - 1]);

    const iniciar = raiz => {
      if (!raiz || raiz.dataset.fichaLista) return;
      const nodoDatos = raiz.querySelector('[data-ficha-datos]');
      const form = raiz.querySelector('[data-ficha-form]');
      if (!nodoDatos || !form) return;
      let datos;
      try { datos = JSON.parse(nodoDatos.textContent); } catch (e) { return; }
      raiz.dataset.fichaLista = '1';

      const T = datos.textos || {};
      const variantes = datos.variantes || [];
      const quedan = datos.quedan || {};
      const iColor = datos.idxColor;
      const pronto = !!datos.pronto;
      const iTalla = datos.idxTalla;
      const sid = raiz.dataset.ficha;
      const inputId = form.querySelector('[data-ficha-id]');
      const boton = form.querySelector('[data-ficha-agregar]');
      const estadoTxt = form.querySelector('[data-ficha-estado]');
      const precioEl = raiz.querySelector('[data-ficha-precio]');
      const campos = [...form.querySelectorAll('[data-opcion]')];
      const nota = form.querySelector('[data-ficha-nota]');
      const error = form.querySelector('[data-ficha-error]');
      const fsTalla = iTalla >= 0 ? form.querySelector('[data-opcion="' + iTalla + '"]') : null;
      const barra = document.querySelector('[data-ficha-barra="' + sid + '"]');
      const pista = raiz.querySelector('.ficha-galeria__pista');
      const fotos = pista ? [...pista.querySelectorAll('.ficha-galeria__foto')] : [];
      const puntos = raiz.querySelector('[data-puntos]');
      const cuenta = raiz.querySelector('[data-foto]');
      const totalFotos = raiz.querySelector('[data-fotos]');
      const unica = variantes.length === 1 && variantes[0].title === 'Default Title';

      if (inputId && !unica) inputId.disabled = false;

      const estado = [];
      campos.forEach(fs => {
        const r = fs.querySelector('input:checked');
        estado[Number(fs.dataset.opcion)] = r ? r.value : null;
      });

      /* ---- Qué está disponible ---- */
      const coincide = (v, i) => v.options.every((o, j) => j === i || estado[j] == null || o === estado[j]);
      const disponible = (i, valor) => variantes.some(v => v.options[i] === valor && (pronto || (v.available && (i === iColor || coincide(v, i)))));
      const actual = () => {
        if (unica) return variantes[0];
        if (estado.some(x => x == null)) return null;
        return variantes.find(v => v.options.every((o, j) => o === estado[j])) || null;
      };

      const pintarOpciones = () => {
        campos.forEach(fs => {
          const i = Number(fs.dataset.opcion);
          fs.querySelectorAll('input[type="radio"]').forEach(r => {
            const si = disponible(i, r.value);
            const sr = r.parentElement.querySelector('[data-agotada]');
            if (sr) sr.hidden = si;
            if (i === iTalla) {
              r.disabled = !si;
              if (!si && r.checked) { r.checked = false; estado[i] = null; }
            } else if (si) r.parentElement.removeAttribute('data-agotado');
            else r.parentElement.setAttribute('data-agotado', '');
          });
          const v = fs.querySelector('[data-valor-elegido]');
          if (v) v.textContent = estado[i] != null ? estado[i] : T.escogeUna;
        });
      };

      /* ---- Galería ---- */
      const visibles = () => fotos.filter(f => !f.hidden);
      const pintarPuntos = () => {
        const v = visibles();
        if (pista) pista.dataset.n = v.length;
        fotos.forEach(f => f.classList.remove('ficha-galeria__foto--ancha'));
        if (v.length > 1 && v.length % 2) v[0].classList.add('ficha-galeria__foto--ancha');
        if (totalFotos) totalFotos.textContent = v.length;
        if (cuenta) cuenta.textContent = 1;
        if (cuenta) cuenta.parentElement.hidden = v.length < 2;
        if (!puntos) return;
        puntos.hidden = v.length < 2;
        puntos.innerHTML = v.map((_, i) => '<button class="ficha-galeria__punto" type="button" aria-label="' + fmt(T.fotoN, { n: i + 1, total: v.length }) + '"' + (i === 0 ? ' aria-current="true"' : '') + '></button>').join('');
      };
      const fotoActual = () => {
        const v = visibles();
        const ancho = (v[0] && v[0].offsetWidth) || 1;
        return Math.min(Math.round(pista.scrollLeft / ancho), v.length - 1);
      };
      let enCola = false;
      if (pista) {
        pista.addEventListener('scroll', () => {
          if (enCola) return;
          enCola = true;
          requestAnimationFrame(() => {
            enCola = false;
            const i = fotoActual();
            if (cuenta) cuenta.textContent = i + 1;
            if (puntos) puntos.querySelectorAll('.ficha-galeria__punto').forEach((b, j) => {
              if (j === i) b.setAttribute('aria-current', 'true'); else b.removeAttribute('aria-current');
            });
          });
        }, { passive: true });
      }
      if (puntos) {
        puntos.addEventListener('click', e => {
          const b = e.target.closest('.ficha-galeria__punto');
          if (!b) return;
          const i = [...puntos.children].indexOf(b);
          const v = visibles();
          if (v[i]) pista.scrollTo({ left: v[i].offsetLeft - v[0].offsetLeft, behavior: reduce.matches ? 'auto' : 'smooth' });
        });
      }
      const ajustarPista = () => {
        if (!pista) return;
        if (telefono.matches && visibles().length > 1) {
          pista.setAttribute('tabindex', '0');
          pista.setAttribute('aria-roledescription', T.deslizable);
        } else {
          pista.removeAttribute('tabindex');
          pista.removeAttribute('aria-roledescription');
        }
      };
      telefono.addEventListener('change', ajustarPista);

      let colorPintado = iColor >= 0 ? estado[iColor] : null;
      const pintarGaleria = () => {
        if (!pista || iColor < 0) return;
        const color = estado[iColor];
        if (color === colorPintado) return;
        colorPintado = color;
        const hay = fotos.some(f => f.dataset.color === color);
        fotos.forEach(f => { f.hidden = hay && f.dataset.color !== '' && f.dataset.color !== color; });
        pista.setAttribute('aria-label', hay ? fmt(T.fotosDeColor, { color: String(color).toLowerCase() }) : T.fotosDe);
        pista.scrollLeft = 0;
        pintarPuntos();
        ajustarPista();
      };

      /* ---- Precio, botón, nota, barra y URL ---- */
      const precioHtml = v => {
        if (v.compare_at_price && v.compare_at_price > v.price) {
          return '<span class="precio"><span class="sr-only">' + T.ahora + ' </span>' + dinero(v.price) + '<span class="sr-only"> ' + T.antes + '</span><s class="precio__antes">' + dinero(v.compare_at_price) + '</s></span>';
        }
        return '<span class="precio">' + dinero(v.price) + '</span>';
      };
      const ponerUrl = v => {
        try {
          const u = new URL(window.location.href);
          if (v) u.searchParams.set('variant', v.id); else u.searchParams.delete('variant');
          window.history.replaceState(window.history.state, '', u.toString());
        } catch (e) { /* sin URL: no pasa nada */ }
      };
      const pintarNota = v => {
        if (!nota) return;
        let txt = '';
        if (v && quedan[v.id]) txt = fmt(quedan[v.id] === 1 && T.quedaUna ? T.quedaUna : T.quedan, { n: quedan[v.id], talla: v.options[iTalla] });
        else {
          const fuera = [...fsTalla.querySelectorAll('input[type="radio"]')].filter(r => r.disabled).map(r => r.value);
          if (fuera.length === 1) txt = fmt(T.agotadaUna, { talla: fuera[0] });
          else if (fuera.length > 1) txt = fmt(T.agotadasVarias, { tallas: juntar(fuera, T.y) });
        }
        nota.textContent = txt;
        if (txt) fsTalla.setAttribute('aria-describedby', nota.id); else fsTalla.removeAttribute('aria-describedby');
      };
      const pintarBarra = v => {
        if (!barra) return;
        const p = barra.querySelector('[data-barra-precio]');
        const d = barra.querySelector('[data-barra-det]');
        const b = barra.querySelector('[data-barra-agregar]');
        if (v && p) p.textContent = dinero(v.price);
        if (d) {
          const partes = [];
          estado.forEach((x, i) => { if (i !== iTalla && x != null) partes.push(x); });
          if (iTalla >= 0) partes.push(estado[iTalla] != null ? T.talla + ' ' + estado[iTalla] : T.escogeTalla);
          d.textContent = partes.join(' · ');
        }
        if (b) b.disabled = pronto || !!(v && !v.available);
      };
      const limpiarError = () => {
        if (!error) return;
        error.hidden = true;
        error.textContent = '';
        if (fsTalla) fsTalla.classList.remove('ficha-opcion--error');
      };

      const actualizar = (porUsuario) => {
        pintarOpciones();
        const v = actual();
        if (inputId) inputId.value = v ? v.id : '';
        if (v && precioEl) precioEl.innerHTML = precioHtml(v);
        if (boton) {
          const agotado = !!(v && !v.available) || (!v && !variantes.some(x => x.available));
          boton.disabled = pronto || agotado;
          boton.textContent = pronto ? T.pronto : agotado ? T.agotado : T.agregar;
        }
        if (fsTalla) pintarNota(v);
        pintarBarra(v);
        pintarGaleria();
        if (porUsuario && !unica) ponerUrl(v);
      };

      form.addEventListener('change', e => {
        const r = e.target.closest('input[type="radio"][data-i]');
        if (!r) return;
        estado[Number(r.dataset.i)] = r.value;
        if (Number(r.dataset.i) === iTalla) limpiarError();
        if (estadoTxt) estadoTxt.textContent = '';
        actualizar(true);
      });

      /* ---- Agregar al carrito ---- */
      let ocupado = false;
      const pedirTalla = () => {
        if (!fsTalla || !error) return;
        error.textContent = T.errorTalla;
        error.hidden = false;
        fsTalla.classList.add('ficha-opcion--error');
        fsTalla.scrollIntoView({ block: 'center', behavior: reduce.matches ? 'auto' : 'smooth' });
        const primera = fsTalla.querySelector('input[type="radio"]:not(:disabled)');
        if (primera) primera.focus({ preventScroll: true });
      };
      const agregar = desde => {
        if (pronto) return;
        const v = actual();
        if (!v) { if (iTalla >= 0 && estado[iTalla] == null) pedirTalla(); else if (estadoTxt) estadoTxt.textContent = T.noHay; return; }
        if (!v.available) { if (estadoTxt) estadoTxt.textContent = T.noHay; return; }
        if (ocupado || !window.Patio) return;
        ocupado = true;
        if (estadoTxt) estadoTxt.textContent = '';
        boton.setAttribute('aria-busy', 'true');
        window.Patio.carrito.agregar(v.id, 1, {}, { desde: desde })
          .catch(err => { if (estadoTxt) estadoTxt.textContent = err.message; })
          .finally(() => { ocupado = false; boton.removeAttribute('aria-busy'); });
      };
      form.addEventListener('submit', e => {
        if (!window.Patio || !window.Patio.carrito) return;
        e.preventDefault();
        agregar(boton);
      });
      if (barra) {
        const b = barra.querySelector('[data-barra-agregar]');
        if (b) b.addEventListener('click', () => {
          if (!actual() && iTalla >= 0) { pedirTalla(); return; }
          agregar(b);
        });
      }

      /* ---- Barra fija: solo cuando el botón principal ya quedó arriba ---- */
      if (barra && boton && 'IntersectionObserver' in window) {
        const io = new IntersectionObserver(([en]) => {
          const ver = !en.isIntersecting && en.boundingClientRect.top < 0 && telefono.matches;
          barra.dataset.visible = String(ver);
          if (ver) barra.removeAttribute('inert'); else barra.setAttribute('inert', '');
        });
        io.observe(boton);
      }

      ajustarPista();
      actualizar(false);
    };

    const todas = (c = document) => c.querySelectorAll('[data-ficha]').forEach(iniciar);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => todas());
    else todas();
    document.addEventListener('shopify:section:load', e => todas(e.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["regalos-empresas"] && !Shopify.designMode) return;
  try {
    
  /* Regalos para empresas: copiar el correo. Sin JS el botón no aparece y el correo se puede seleccionar. */
  (() => {
    const mostrar = () => document.querySelectorAll('[data-rg-copiar]').forEach(b => { b.hidden = false; });
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mostrar);
    else mostrar();
    document.addEventListener('shopify:section:load', mostrar);
    document.addEventListener('click', async e => {
      const b = e.target.closest && e.target.closest('[data-rg-copiar]');
      if (!b) return;
      const caja = b.closest('[data-rg-empresas]');
      const estado = caja && caja.querySelector('[data-rg-copiado]');
      let ok = false;
      try { await navigator.clipboard.writeText(b.dataset.rgCopiar); ok = true; } catch (err) {
        /* Sin permiso para el portapapeles: deja el correo seleccionado */
        const dir = caja && caja.querySelector('.rg-empresas__dir');
        if (dir && window.getSelection) {
          const r = document.createRange();
          r.selectNodeContents(dir);
          const s = window.getSelection();
          s.removeAllRanges();
          s.addRange(r);
        }
      }
      if (estado) estado.textContent = ok ? b.dataset.ok : b.dataset.falla;
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["regalos-guia"]) return;
  try {
    
  /* Guía de regalos: el selector filtra lo que ya está en la página, sin recargar, y la URL guarda lo escogido.
     El regalo resuelto agrega sus piezas al carrito de un jalón. */
  (() => {
    const fmt = (t, v) => String(t || '').replace(/\{(\w+)\}/g, (m, k) => (k in v ? v[k] : m));

    const iniciar = raiz => {
      if (!raiz || raiz.dataset.rgListo) return;
      raiz.dataset.rgListo = 'si';
      const form = raiz.querySelector('[data-rg-selector]');
      if (!form) return;
      let t = {};
      try { t = JSON.parse(raiz.querySelector('[data-rg-textos]').textContent); } catch (e) { t = {}; }
      const piezas = [...raiz.querySelectorAll('[data-rg-pieza]')];
      const grupos = [...raiz.querySelectorAll('[data-rg-grupo]')];
      const estado = raiz.querySelector('[data-rg-estado]');
      const verTodo = raiz.querySelector('[data-rg-ver-todo]');
      const resuelto = raiz.querySelector('[data-rg-resuelto]');
      const vacio = raiz.querySelector('[data-rg-vacio]');
      const vacioTexto = raiz.querySelector('[data-rg-vacio-texto]');
      const arriba = raiz.querySelector('[data-rg-arriba]');
      const abajo = raiz.querySelector('[data-rg-abajo]');
      const c1 = Number(raiz.dataset.c1) || 100000;
      const c2 = Number(raiz.dataset.c2) || 250000;
      const PRECIO = {
        '': [0, Infinity],
        [raiz.dataset.menos]: [0, c1 - 1],
        [raiz.dataset.entre]: [c1, c2],
        [raiz.dataset.mas]: [c2 + 1, Infinity]
      };
      const valor = n => { const i = form.querySelector('input[name="' + n + '"]:checked'); return i ? i.value : ''; };
      const frase = n => { const i = form.querySelector('input[name="' + n + '"]:checked'); return i ? i.dataset.frase : ''; };
      const pasa = (li, para, precio) => {
        const p = Number(li.dataset.precio);
        const r = PRECIO[precio] || PRECIO[''];
        return (para === 'todas' || li.dataset.para === para) && p >= r[0] && p <= r[1];
      };
      const regalos = n => (n === 1 ? t.uno : fmt(t.varios, { n }));

      const aplicar = () => {
        const para = valor('para');
        const precio = valor('precio');
        const marcas = new Set();
        let n = 0;
        piezas.forEach(li => {
          const ok = pasa(li, para, precio);
          li.hidden = !ok;
          if (ok) { n++; marcas.add(li.dataset.marca); }
        });
        grupos.forEach(g => {
          const v = g.querySelectorAll('[data-rg-pieza]:not([hidden])').length;
          g.hidden = v === 0;
          const c = g.querySelector('[data-rg-cuenta]');
          if (c) c.textContent = regalos(v);
        });
        /* Cuántos hay en cada opción, con lo otro que ya escogiste */
        form.querySelectorAll('input[name="para"]').forEach(i => {
          const c = piezas.filter(li => pasa(li, i.value, precio)).length;
          const s = i.closest('.rg-op').querySelector('[data-n]');
          if (s) s.textContent = c;
          i.closest('.rg-op').classList.toggle('rg-op--cero', c === 0);
        });
        form.querySelectorAll('input[name="precio"]').forEach(i => {
          const s = i.closest('.rg-op').querySelector('[data-n]');
          if (!s) return;
          const c = piezas.filter(li => pasa(li, para, i.value)).length;
          s.textContent = c;
          i.closest('.rg-op').classList.toggle('rg-op--cero', c === 0);
        });

        const filtrado = para !== 'todas' || precio !== '';
        const dicho = [frase('para'), frase('precio')].filter(Boolean).join(' ');
        if (estado) {
          estado.textContent = filtrado
            ? regalos(n) + ' ' + dicho
            : (marcas.size === 1 ? fmt(t.deUnaMarca, { regalos: regalos(n) }) : fmt(t.deMarcas, { regalos: regalos(n), marcas: marcas.size }));
        }
        if (verTodo) verTodo.hidden = !filtrado;
        if (resuelto) resuelto.hidden = !((para === 'todas' || para === resuelto.dataset.para) && precio === '');
        if (vacio) vacio.hidden = n !== 0;
        if (!n && vacioTexto) vacioTexto.textContent = fmt(t.nada, { frase: dicho });

        /* Los tramos del muro: sin huecos dobles cuando el regalo resuelto o lo de abajo se esconden */
        const sinResuelto = !resuelto || resuelto.hidden;
        if (abajo) {
          const conAbajo = [...abajo.querySelectorAll('[data-rg-grupo]')].some(g => !g.hidden) || (!!vacio && abajo.contains(vacio) && !vacio.hidden);
          abajo.hidden = !conAbajo;
          abajo.toggleAttribute('data-pegado', sinResuelto);
          if (arriba) arriba.toggleAttribute('data-final', sinResuelto && !conAbajo);
        }

        /* La URL cambia sin recargar */
        try {
          const u = new URL(window.location.href);
          if (para === 'todas') u.searchParams.delete('para'); else u.searchParams.set('para', para);
          if (precio === '') u.searchParams.delete('precio'); else u.searchParams.set('precio', precio);
          history.replaceState(history.state, '', u.pathname + u.search + u.hash);
        } catch (e) { /* sin historial */ }
      };

      const poner = (para, precio) => {
        const a = form.querySelector('input[name="para"][value="' + CSS.escape(para) + '"]');
        const b = form.querySelector('input[name="precio"][value="' + CSS.escape(precio) + '"]');
        if (a) a.checked = true;
        if (b) b.checked = true;
      };

      /* Lo que venga en la liga: ?para=ella o #para-ella (desde la portada) */
      let saltar = false;
      try {
        const q = new URLSearchParams(window.location.search);
        const h = window.location.hash.match(/^#para-([a-z0-9-]+)$/);
        poner(q.get('para') || (h && h[1]) || 'todas', q.get('precio') || '');
        saltar = !!h;
      } catch (e) { /* liga rara: se queda todo */ }

      form.addEventListener('change', aplicar);
      form.addEventListener('submit', e => e.preventDefault());
      if (verTodo) verTodo.addEventListener('click', () => {
        poner('todas', '');
        aplicar();
        const i = form.querySelector('input[name="para"]:checked');
        if (i) i.focus();
      });
      const cualquiera = raiz.querySelector('[data-rg-cualquier-precio]');
      if (cualquiera) cualquiera.addEventListener('click', () => {
        poner(valor('para'), '');
        aplicar();
        const i = form.querySelector('input[name="precio"]:checked');
        if (i) i.focus();
      });
      aplicar();
      if (saltar) requestAnimationFrame(() => raiz.scrollIntoView({ block: 'start' }));
    };

    /* Regalo resuelto: las piezas al carrito de un jalón; el cajón muestra un paquete por marca */
    document.addEventListener('click', e => {
      const b = e.target.closest && e.target.closest('[data-rg-tres]');
      if (!b || b.disabled || b.getAttribute('aria-busy') === 'true') return;
      const caja = b.closest('.rg-resuelto__acciones');
      const aviso = caja && caja.querySelector('[data-rg-error]');
      let items = [];
      try { items = JSON.parse(b.dataset.rgTres); } catch (err) { items = []; }
      if (!items.length || !window.Patio || !window.Patio.carrito) return;
      if (aviso) aviso.textContent = '';
      b.setAttribute('aria-busy', 'true');
      window.Patio.carrito.agregar(items, 1, {}, { desde: b, mensaje: b.dataset.mensaje })
        .catch(err => {
          const raiz = b.closest('[data-rg-guia]');
          let t = {};
          try { t = JSON.parse(raiz.querySelector('[data-rg-textos]').textContent); } catch (e2) { t = {}; }
          if (aviso) aviso.textContent = (err && err.message) || t.error || '';
        })
        .finally(() => b.removeAttribute('aria-busy'));
    });

    const todo = () => document.querySelectorAll('[data-rg-guia]').forEach(iniciar);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', todo);
    else todo();
    document.addEventListener('shopify:section:load', e => { const r = e.target.querySelector('[data-rg-guia]'); if (r) iniciar(r); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vende-solicitud"]) return;
  try {
    
  /* Solicitud de marca: revisa cada campo y deja el error junto a él. Si todo está bien, el formulario
     se manda normal a Shopify (formulario de contacto). Al volver, la confirmación saluda por nombre. */
  (() => {
    const CLAVE = 'patio-solicitud-marca';
    const iniciar = (raiz) => {
      if (!raiz || raiz.dataset.listo) return;
      raiz.dataset.listo = '1';
      let T = {};
      try { T = JSON.parse(raiz.querySelector('[data-textos]').textContent); } catch (e) {}

      /* Ya se mandó: la confirmación toma el nombre, la marca y el correo que se guardaron al mandar */
      const conf = raiz.querySelector('[data-confirmacion]');
      if (conf) {
        let datos = null;
        try { datos = JSON.parse(sessionStorage.getItem(CLAVE) || 'null'); sessionStorage.removeItem(CLAVE); } catch (e) {}
        if (datos && datos.nombre) {
          const coma = conf.querySelector('[data-c="nombre-coma"]');
          if (coma && T.gracias_nombre) {
            conf.querySelector('h3').textContent = String(T.gracias_nombre).replace('[nombre]', datos.nombre);
          }
          const p = conf.querySelector('[data-c-texto]');
          if (p && T.lista_detalle && datos.marca && datos.correo) {
            p.textContent = String(T.lista_detalle).replace('[marca]', datos.marca).replace('[correo]', datos.correo);
          }
        }
        const h = conf.querySelector('h3');
        if (h) { h.focus({ preventScroll: true }); conf.scrollIntoView({ block: 'center' }); }
        return;
      }

      const forma = raiz.querySelector('form');
      const caja = raiz.querySelector('[data-forma]');
      if (!forma || !caja) return;
      forma.noValidate = true;

      const servidor = raiz.querySelector('[data-error-servidor]');
      if (servidor) servidor.focus();

      const estado = raiz.querySelector('[data-estado]');
      const grupo = raiz.querySelector('[data-grupo="shopify"]');
      const campo = n => forma.querySelector(`[data-regla="${n}"]`);
      const valor = n => {
        if (n === 'shopify') { const r = forma.querySelector('[data-regla="shopify"]:checked'); return r ? r.value : ''; }
        const c = campo(n); return c ? c.value : '';
      };
      const limpia = v => String(v || '').trim();
      const reglas = {
        marca: v => limpia(v).length >= 2,
        instagram: v => {
          const u = limpia(v).replace(/^https?:\/\/(www\.)?instagram\.com\//i, '').replace(/[/?].*$/, '').replace(/^@/, '');
          return /^[A-Za-z0-9._]{1,30}$/.test(u);
        },
        sitio: v => !limpia(v) || /^(https?:\/\/)?[^\s/.]+(\.[^\s/.]+)+(\/\S*)?$/i.test(limpia(v)),
        categoria: v => !!v,
        ciudad: v => limpia(v).length >= 2,
        shopify: v => !!v,
        nombre: v => limpia(v).length >= 2,
        correo: v => /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(limpia(v))
      };
      const nombres = Object.keys(reglas).filter(n => n === 'shopify' ? !!grupo : !!campo(n));
      const error = n => {
        const c = n === 'shopify' ? grupo : campo(n);
        const id = (c.getAttribute('aria-describedby') || '').split(' ').find(x => x.endsWith('-e-' + n));
        return id ? document.getElementById(id) : null;
      };
      let intentado = false;

      const revisar = n => {
        const ok = reglas[n](valor(n));
        const err = error(n);
        if (err) { err.textContent = ok ? '' : (T[n] || ''); err.hidden = ok; }
        if (n === 'shopify') {
          grupo.dataset.invalid = String(!ok);
          grupo.querySelectorAll('input').forEach(i => ok ? i.removeAttribute('aria-invalid') : i.setAttribute('aria-invalid', 'true'));
        } else {
          const c = campo(n);
          if (ok) c.removeAttribute('aria-invalid'); else c.setAttribute('aria-invalid', 'true');
        }
        return ok;
      };
      const contar = k => k === 0 ? '' : k === 1 ? T.falta_uno : String(T.faltan).replace('[n]', k);

      forma.addEventListener('submit', e => {
        intentado = true;
        const malos = nombres.filter(n => !revisar(n));
        if (malos.length) {
          e.preventDefault();
          estado.textContent = contar(malos.length);
          const primero = malos[0] === 'shopify' ? grupo.querySelector('input') : campo(malos[0]);
          if (primero) primero.focus();
          return;
        }
        estado.textContent = '';
        try {
          sessionStorage.setItem(CLAVE, JSON.stringify({ nombre: limpia(valor('nombre')), marca: limpia(valor('marca')), correo: limpia(valor('correo')) }));
        } catch (err) {}
      });

      /* Después del primer intento, cada campo se revisa al corregirlo */
      const alCambiar = e => {
        const n = e.target.dataset && e.target.dataset.regla;
        if (!intentado || !n || !(n in reglas)) return;
        revisar(n);
        const quedan = nombres.filter(k => { const er = error(k); return er && !er.hidden; }).length;
        estado.textContent = contar(quedan);
      };
      forma.addEventListener('input', alCambiar);
      forma.addEventListener('change', alCambiar);
    };
    const todo = () => document.querySelectorAll('[data-solicitud]').forEach(iniciar);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', todo);
    else todo();
    document.addEventListener('shopify:section:load', e => e.target.querySelectorAll('[data-solicitud]').forEach(iniciar));
  })();

  } catch(e) { console.error(e); }
})();
})();
